module.exports = __webpack_public_path__ + "img/triangle-top.29a4ee1e.png";